import type { ReactNode } from "react";
import Button from "ui/buttons/Button";
import Link from "ui/components/Link";
import cx from "ui/cx";
import IconUpArrow from "ui/icons/IconUpArrow";
import styles from "./ProductCard.module.scss";

export interface ProductCardProps {
  icon?: ReactNode;
  title: string;
  subtitle: string;
  size?: "small" | "large";
  href: string;
  ctaText?: string;
  disabled?: boolean;
}

export function ProductCards({ children }: { children: React.ReactNode }) {
  return <div className={styles.productCards}>{children}</div>;
}

export default function ProductCard({
  icon,
  title,
  subtitle,
  size = "small",
  href,
  ctaText = "Manage",
  disabled = false,
}: ProductCardProps) {
  const classNames = cx(styles.wrapper, size === "large" && styles.large, disabled && styles.disabled);

  return (
    <div className={classNames} aria-label={disabled ? title : `Go to ${title}`} aria-disabled={disabled || undefined}>
      {!disabled && <Link href={href} className={styles.cardLink} />}
      <div className="header">
        {icon}
        <div className="content">
          <span className="title">{title}</span>
          <span className="subtitle">{subtitle}</span>
        </div>
      </div>
      <div className="footer">
        <div className="cta-container">
          {!disabled && (
            <Link href={href}>
              <Button btnStyle="green" btnSize="none" className="card-cta">
                <span>{ctaText}</span>
                <IconUpArrow />
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
